module.exports = __webpack_public_path__ + "static/img/yuqjdeyy.724b1aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/yuqjdeyy.png
// module id = gw6V
// module chunks = 0